import gql from 'graphql-tag';
import { ProuniApplication, ProuniEligibility } from '@/store/modules/prouni/types';

export interface GetMyProuniApplicationResult {
  getMyProuniApplication: ProuniApplication | null;
}

export interface GetMyProuniEligibilityResult {
  getMyProuniEligibility: ProuniEligibility;
}

export interface GetProuniDocumentUploadUrlResult {
  getProuniDocumentUploadUrl: {
    uploadUrl: string;
    key: string;
    expiresAt: string;
  };
}

export const getMyProuniEligibility = gql`
  query getMyProuniEligibility {
    getMyProuniEligibility {
      isEligible
      course
    }
  }
`;

export const getMyProuniApplication = gql`
  query getMyProuniApplication {
    getMyProuniApplication {
      id
      status
      ra
      rejectionReason
      fullName
      cpf
      email
      phone
      birthDate
      gender
      sisProuniInscriptionNumber
      docType
      rgNumber
      issueDate
      issuingBody
      uf
      isOfAge
      addressZipCode
      addressStreet
      addressNumber
      addressComplement
      addressNeighborhood
      addressCity
      addressState
      residenceProofType
      income
      activityType
      hasAlimony
      institutionType
      isPublicSchoolTeacher
      hasDisability
      contactMethod
      acceptedTerms
      pipelineState
      familyMembers {
        id
        name
        income
      }
      documents {
        id
        documentType
        fileName
        mimeType
        status
        rejectionReason
        familyMemberId
        description
        url
      }
    }
  }
`;

export const getProuniDocumentUploadUrl = gql`
  query getProuniDocumentUploadUrl(
    $fileName: String!
    $contentType: String!
    $documentType: ProuniDocumentType!
    $familyMemberId: Float
  ) {
    getProuniDocumentUploadUrl(
      fileName: $fileName
      contentType: $contentType
      documentType: $documentType
      familyMemberId: $familyMemberId
    ) {
      uploadUrl
      key
      expiresAt
    }
  }
`;
